export default {
  namespaced: true,
  state: {
    dragSurface: false,
    contributionOverlay: null,
    cordova: false,
    modal: null,
    modalIsLoading: false,
    mapSync: null,
    touchscreen: false
  },
  mutations: {
    showDragSurface(state) {
      state.dragSurface = true
    },
    hideDragSurface(state) {
      state.dragSurface = false
    },
    showContributionOverlay(state, url) {
      state.contributionOverlay = url
    },
    hideContributionOverlay(state) {
      state.contributionOverlay = null
    },
    toggleCordova(state) {
      state.cordova = true
    },
    showModal(state, modal) {
      state.modal = modal
    },
    setModalLoading(state, isLoading) {
      state.modalIsLoading = isLoading
    },
    mapSync(state, center) {
      state.mapSync = center
    },
    setTouchscreen(state, isTouchscreen) {
      state.touchscreen = isTouchscreen
    }
  },
  actions: {
    showDragSurface(context) {
      context.commit('showDragSurface')
    },
    hideDragSurface(context) {
      context.commit('hideDragSurface')
    },
    showContributionOverlay(context, url) {
      context.commit('showContributionOverlay', url)
    },
    hideContributionOverlay(context) {
      context.commit('hideContributionOverlay')
    },
    toggleCordova(context) {
      context.commit('toggleCordova')
    },
    showModal(context, modal) {
      context.commit('showModal', modal)
    },
    closeModal(context) {
      context.commit('showModal', null)
    },
    setModalLoading(context, isLoading) {
      context.commit('showModal', isLoading)
    },
    mapSync(context, center) {
      context.commit('mapSync', center)
    },
    setTouchscreen(context, isTouchscreen) {
      context.commit('setTouchscreen', isTouchscreen)
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/runtime.js